/**
 * Platform-level brand — used on surfaces that are NOT tenant-scoped:
 * login, signup, platform admin, fallback transactional email when no agency
 * context is available.
 *
 * Tenant-facing surfaces (landing on a custom domain, PWA, emails sent as
 * the tenant) resolve brand from the agency doc via resolve-brand.ts.
 */
import { CUSTOM_BRAND } from "@/config/landing";

export const PLATFORM_BRAND = {
  name: CUSTOM_BRAND.name,
  tagline: CUSTOM_BRAND.tagline,
  shortDescription: CUSTOM_BRAND.shortDescription,
  supportEmail: CUSTOM_BRAND.supportEmail,
  primaryDomain: CUSTOM_BRAND.primaryDomain,
} as const;

export type PlatformBrand = typeof PLATFORM_BRAND;
